
import {request} from '@/network/request'

export function fetchList(query) {
  return request({
    url: '/gaoligong/dryblade/page',
    method: 'get',
    params: query
  })
}

export function addObj(obj) {
  return request({
    url: '/gaoligong/dryblade',
    method: 'post',
    data: obj
  })
}

export function getObj(id) {
  return request({
    url: '/gaoligong/dryblade/' + id,
    method: 'get'
  })
}

export function delObj(id) {
  return request({
    url: '/gaoligong/dryblade/' + id,
    method: 'delete'
  })
}

export function putObj(obj) {
  return request({
    url: '/gaoligong/dryblade',
    method: 'put',
    data: obj
  })
}
